import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { showingDiscardedFormSubmissions, showDiscardedSubmissions, showOpenSubmissions } from "reduxSlices/formSubmissionTableSlice"
import Switch from "shared/Switch"

const SubmissionDeletedFilter = () => {
  const dispatch = useDispatch()
  const discardedVisible = useSelector(showingDiscardedFormSubmissions)
  const reducer = discardedVisible ? showOpenSubmissions : showDiscardedSubmissions
  const toggleFunction = () => dispatch(reducer())

  return (
    <div className="p-6 border-b border-lightgray-3">
      <div className="font-semibold flex-center">
        Show deleted submissions
        <Switch
          checked={discardedVisible}
          onChange={toggleFunction}
        />
      </div>
      <span className="text-xs text-dark">Previous six months</span>
    </div>
  )
}

export default SubmissionDeletedFilter
